import { render } from "./PDAnalyticsChart.vue?vue&type=template&id=062bbf29&scoped=true"
import script from "./PDAnalyticsChart.vue?vue&type=script&lang=ts"
export * from "./PDAnalyticsChart.vue?vue&type=script&lang=ts"

import "./PDAnalyticsChart.vue?vue&type=style&index=0&id=062bbf29&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-062bbf29"

export default script